"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = useMounted;
var _react = require("react");
/**
 * @typedef {Object} useMountedResponse
 * @property {Boolean} isMounted - Indicator if a component is mounted or not.
 */

/**
 * Hook used to track if a component is currently mounted or not.
 * @function useMounted
 * @example
 * const {isMounted} = useMounted();
 * @returns {useMountedResponse} - The mount state.
 */
function useMounted() {
  const isMounted = (0, _react.useRef)(true);
  (0, _react.useEffect)(() => {
    return () => {
      isMounted.current = false;
    };
  }, []);
  return {
    isMounted: isMounted.current
  };
}